package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import com.jingfangpai.common.orm.mapping.enums.ContentEntityType
import kotlin.String
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentQuery
import com.jingfangpai.contentEntity.model.ContentConnectionDto
import com.jingfangpai.common.orm.mapping.Content

object ContentApiClient :BaseServiceClient() {

	@JsName("fetch")
	fun fetch(entityType:com.jingfangpai.common.orm.mapping.enums.ContentEntityType,entityId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"entityType" to "${entityType?:""}",
			"entityId" to "${entityId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>> = httpClient.get {
				    url("/api/content/fetch?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getConnectionsPerContent")
	fun getConnectionsPerContent(contentEntityType:com.jingfangpai.common.orm.mapping.enums.ContentEntityType,contentEntityId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.Map<kotlin.String, com.jingfangpai.contentEntity.model.ContentConnections>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"contentEntityType" to "${contentEntityType?:""}",
			"contentEntityId" to "${contentEntityId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.Map<kotlin.String, com.jingfangpai.contentEntity.model.ContentConnections>> = httpClient.post {
				    url("/api/content/connections/getPerContent?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getContainers")
	fun getContainers(entityType:com.jingfangpai.common.orm.mapping.enums.ContentEntityType,entityId:kotlin.String,parentId:kotlin.String?, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"entityType" to "${entityType?:""}",
			"entityId" to "${entityId?:""}",
			"parentId" to "${parentId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>> = httpClient.get {
				    url("/api/content/getContainers?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getContent")
	fun getContent(type:com.jingfangpai.common.orm.mapping.enums.ContentType,id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"type" to "${type?:""}",
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo> = httpClient.get {
				    url("/api/content/get?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("query")
	fun query(query:com.jingfangpai.content.model.ContentQuery, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>> = httpClient.post {
				    url("/api/content/query?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.content.model.ContentQuery.serializer(),query), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveConnection")
	fun saveConnection(contentConnection:com.jingfangpai.contentEntity.model.ContentConnectionDto, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.contentEntity.model.ContentConnectionDto>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.contentEntity.model.ContentConnectionDto> = httpClient.post {
				    url("/api/content/connection/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.contentEntity.model.ContentConnectionDto.serializer(),contentConnection), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveContent")
	fun saveContent(content:com.jingfangpai.common.orm.mapping.Content, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo> = httpClient.post {
				    url("/api/content/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.Content.serializer(),content), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
